/* eslint-disable no-param-reassign */
import { API_CREATE_FAVORITE, API_CREATE_FAVORITE_SUCCESS, API_DELETE_FAVORITE, API_DELETE_FAVORITE_MANY, } from '../actions/FavoriteActions';
/**
 * favoriteの予測更新
 * @param solution
 * @param type
 */
const prepareFavorite = (solution, type) => {
    const addCount = type === API_CREATE_FAVORITE ? 1 : -1;
    const hasFavorite = type === API_CREATE_FAVORITE;
    solution.favoriteCount += addCount;
    solution.hasFavorite = hasFavorite;
};
/**
 * favoriteの更新
 * @param solution
 * @param count
 * @param type
 */
const completeFavorite = (solution, { count }, type) => {
    const hasFavorite = type === API_CREATE_FAVORITE_SUCCESS;
    solution.favoriteCount = count || 0;
    solution.hasFavorite = hasFavorite;
};
/**
 * favoriteの更新
 * @param solution
 * @param payload
 * @param type
 */
export const updateFavorite = (solution, payload, type) => {
    if ([
        API_CREATE_FAVORITE,
        API_DELETE_FAVORITE,
        API_DELETE_FAVORITE_MANY,
    ].includes(type)) {
        prepareFavorite(solution, type);
    }
    else {
        completeFavorite(solution, payload, type);
    }
};
/**
 * favoriteの一括更新
 * @param list
 * @param meta
 * @param payload
 * @param type
 */
export const updateFavoriteList = (list, meta, payload, type) => {
    const ids = meta.ids || [meta.id];
    ids.forEach((id) => {
        Object.values(list || {}).forEach((solution) => {
            if (solution.id === id) {
                updateFavorite(solution, payload || {}, type);
            }
        });
    });
};
